module.exports = __webpack_public_path__ + "static/media/ready-for-selfpickup.f77e02d5.gif";